<template>
    <div class="line-broadcast-page">
        <vue-headful title="ALICE | Broadcast"></vue-headful>
        <div class="line-broadcast-header">
            <p v-if="!isOnCreateLineBroadcastPage" class="head-title">Broadcast</p>
            <div v-else class="broadcast-breadcrumb">
              <p class="origin-level" @click="onClickBroadcastBreadcrumb">Broadcast </p>
              <div>
                <i class="bx bx-chevron-right"></i>
              </div>
              <p class="head-title"> Create Broadcast</p>
            </div>
        </div>
        <CreateLineBroadcast
          v-if="isOnCreateLineBroadcastPage"
          :isMediaStorageChecked="isMediaStorageChecked"
          @on-media-storage-check="onMediaStorageCheck"
        />
        <LineBroadcastList
          v-else
          @on-media-storage-check="onMediaStorageCheck"
        />
    </div>
</template>

<script>
import LineBroadcastList from '@/components/Broadcast/Line/LineBroadcastList.vue';
import CreateLineBroadcast from '@/components/Broadcast/Line/CreateLineBroadcast.vue';

export default {
  name: 'LineBroadcast',
  components: {
    LineBroadcastList,
    CreateLineBroadcast,
  },
  data() {
    return {
      isMediaStorageChecked: false,
    };
  },
  methods: {
    onClickBroadcastBreadcrumb() {
      this.$router.push({ path: '/line-broadcast' });
    },
    onMediaStorageCheck(isChecked) {
      this.isMediaStorageChecked = isChecked;
    },
  },
  computed: {
    isOnCreateLineBroadcastPage() {
      return this.$route.path === '/line-broadcast/create' || this.$route.path === '/line-broadcast/create/';
    },
  },
};
</script>

<style lang="scss" scoped>
.line-broadcast-page{
  .line-broadcast-header {
    background-color: #FFFFFF;
    padding: 20px 24px 20px 35px;
    display: flex;
    justify-content: start;
    align-items: center;
    font-size: 20px;
    line-height: 24px;
    font-weight: 600;
    text-align: left;
    margin-bottom: 24px;
    .broadcast-breadcrumb {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      .head-title {
        color: #111B49;
        margin-bottom: 0px;
      }
      .origin-level{
        color: #868BA6;
        margin-bottom: 0px;
        cursor: pointer;
      }
      i{
        color: #868BA6;
        font-size: 24px;
       }
    }
  }
}
</style>
